import React from 'react';
// Components
import StatusMessage from './StatusMessage';
import Button from './Button';
// Hook
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const NotFound = () => {
  useDocumentTitle('Page not found');
  return (
    <StatusMessage
      glyph='404'
      title='This reel is missing.'
      action={
<Button text='Back to the index' to='/' />
      }
    >
      The page you’re looking for doesn’t exist — but plenty of movies do.
    </StatusMessage>
  );
};

export default NotFound;
